
import { Button } from "@/components/ui/button";
import { ListCheck } from "lucide-react";
import { Link } from "react-router-dom";
import RoleDashboard from "../components/RoleDashboard";

const Dashboard = () => {
  return (
    <div className="space-y-8">
      <RoleDashboard />
      
      <div className="flex justify-end">
        <Button asChild>
          <Link to="/tasks">
            <ListCheck className="mr-2 h-4 w-4" />
            View All Tasks
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default Dashboard;
